module.exports = __webpack_public_path__ + "img/trash-can-undo.00b287cb.svg";